export type AmpAppId = 'platform' | 'admin' | 'partner';

export const APP_NAME_KEYS = {
  admin: 'admin.appName',
  partner: 'partner.appName',
  platform: 'platform.appName',
} as const satisfies Record<AmpAppId, string>;

interface AmpNavItem {
  labelKey: string;
  link: string;
  testId: string;
  fontIcon?: string;
}

export interface AmpAppShellConfig {
  appId: AmpAppId;
  appNameKey: (typeof APP_NAME_KEYS)[AmpAppId];
  logoUrl: string;
  nav: AmpNavItem[];
}
